import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/* Modules */
import { MaterialModule } from '@app/shared/modules/material.module';

/* Components */
import { SpinnerContentComponent } from './spinner-content.component';

@NgModule({
  declarations: [SpinnerContentComponent],
  imports: [CommonModule, MaterialModule],
  exports: [SpinnerContentComponent]
})
export class SpinnerContentModule {}
